module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%= namespace %> h1 { <%= headline_font_size.length>0? 'font-size: '+headline_font_size+';' : '' %> <%= headline_font_color.length>0? 'color: '+headline_font_color+';' : '' %> } <%= namespace %>, <%= namespace %> form label { <%= text_font_size.length>0? 'font-size: '+text_font_size+';' : '' %> <%= text_font_color.length>0? 'color: '+text_font_color+';' : '' %> } <%= namespace %> .has-error .error-message { <%= error_font_size.length>0? 'font-size: '+error_font_size+';' : '' %> <%= error_font_color.length>0? 'color: '+error_font_color+';' : '' %> } <%= namespace %> a, <%= namespace %> a:hover, <%= namespace %> div.checkbox a, <%= namespace %> div.checkbox a:hover { <%= link_font_size.length>0? 'font-size: '+link_font_size+';' : '' %> <%= link_font_color.length>0? 'color: '+link_font_color+';' : '' %> <%= link_text_decoration.length>0? 'text-decoration: '+link_text_decoration+';' : '' %> } <%= namespace %> input:-moz-placeholder, <%= namespace %> input::-moz-placeholder { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> } <%= namespace %> input:-ms-input-placeholder, <%= namespace %> select:-ms-input-placeholder { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> } <%= namespace %> select:-moz-placeholder, <%= namespace %> select::-moz-placeholder { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> } <%= namespace %> input:not([type=checkbox]):not([type=radio]), <%= namespace %> input:not([type=checkbox]):not([type=radio]):focus, <%= namespace %> .styled-select { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> <%= fields_border.length>0? 'outline: '+fields_border+';' : '' %> } <%= namespace %> select, <%= namespace %> select option { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> } <%= namespace %> input::-webkit-input-placeholder, <%= namespace %> select::-webkit-input-placeholder { <%= input_font_size.length>0? 'font-size: '+input_font_size+';' : '' %> <%= input_font_color.length>0? 'color: '+input_font_color+';' : '' %> } <%= namespace %> input, <%= namespace %> .styled-select, <%= namespace %> .styled-select select option { <%= input_background.color.length>0? 'background-color: '+input_background.color+';' : '' %> } <%= namespace %> input[type=checkbox] + label:before { <%= checkbox.background_color.length>0? 'background-color: '+checkbox.background_color+';' : '' %> } <%= namespace %> input[type=checkbox] + label:after { <%= checkbox.checkmark_color.length>0? 'border-color: '+checkbox.checkmark_color+';' : '' %> } <%= namespace %> .styled-select svg{ fill: <%= select_arrow_bg_color.length > 0? select_arrow_bg_color: '#000' %>; } <%= namespace %> .dob-container svg{ fill: <%= select_arrow_bg_color.length > 0? select_arrow_bg_color: '#000' %>; } <%= namespace %> button, <%= namespace %> button:hover { <%= buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' %> <%= buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' %> <%= buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' %> <%= buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' %> <%= buttons.background.length>0? 'background: '+buttons.background+';' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -moz-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -o-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -ms-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' %> } <%= namespace %> button svg, <%= namespace %> button svg poly, <%= namespace %> button svg rect, <%= namespace %> button svg path, <%= namespace %> button:hover svg, <%= namespace %> button:hover svg poly, <%= namespace %> button:hover svg rect, <%= namespace %> button:hover svg path { <%= buttons.text_color.length>0? 'fill: '+buttons.text_color+';' : '' %> }"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append(escapeFn( namespace ))
    ; __append(" h1 { ")
    ; __append(escapeFn( headline_font_size.length>0? 'font-size: '+headline_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( headline_font_color.length>0? 'color: '+headline_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(", ")
    ; __append(escapeFn( namespace ))
    ; __append(" form label { ")
    ; __append(escapeFn( text_font_size.length>0? 'font-size: '+text_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( text_font_color.length>0? 'color: '+text_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .has-error .error-message { ")
    ; __append(escapeFn( error_font_size.length>0? 'font-size: '+error_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( error_font_color.length>0? 'color: '+error_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" a, ")
    ; __append(escapeFn( namespace ))
    ; __append(" a:hover, ")
    ; __append(escapeFn( namespace ))
    ; __append(" div.checkbox a, ")
    ; __append(escapeFn( namespace ))
    ; __append(" div.checkbox a:hover { ")
    ; __append(escapeFn( link_font_size.length>0? 'font-size: '+link_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( link_font_color.length>0? 'color: '+link_font_color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( link_text_decoration.length>0? 'text-decoration: '+link_text_decoration+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input:-moz-placeholder, ")
    ; __append(escapeFn( namespace ))
    ; __append(" input::-moz-placeholder { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input:-ms-input-placeholder, ")
    ; __append(escapeFn( namespace ))
    ; __append(" select:-ms-input-placeholder { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" select:-moz-placeholder, ")
    ; __append(escapeFn( namespace ))
    ; __append(" select::-moz-placeholder { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input:not([type=checkbox]):not([type=radio]), ")
    ; __append(escapeFn( namespace ))
    ; __append(" input:not([type=checkbox]):not([type=radio]):focus, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .styled-select { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( fields_border.length>0? 'outline: '+fields_border+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" select, ")
    ; __append(escapeFn( namespace ))
    ; __append(" select option { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input::-webkit-input-placeholder, ")
    ; __append(escapeFn( namespace ))
    ; __append(" select::-webkit-input-placeholder { ")
    ; __append(escapeFn( input_font_size.length>0? 'font-size: '+input_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( input_font_color.length>0? 'color: '+input_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .styled-select, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .styled-select select option { ")
    ; __append(escapeFn( input_background.color.length>0? 'background-color: '+input_background.color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input[type=checkbox] + label:before { ")
    ; __append(escapeFn( checkbox.background_color.length>0? 'background-color: '+checkbox.background_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" input[type=checkbox] + label:after { ")
    ; __append(escapeFn( checkbox.checkmark_color.length>0? 'border-color: '+checkbox.checkmark_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .styled-select svg{ fill: ")
    ; __append(escapeFn( select_arrow_bg_color.length > 0? select_arrow_bg_color: '#000' ))
    ; __append("; } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .dob-container svg{ fill: ")
    ; __append(escapeFn( select_arrow_bg_color.length > 0? select_arrow_bg_color: '#000' ))
    ; __append("; } ")
    ; __append(escapeFn( namespace ))
    ; __append(" button, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover { ")
    ; __append(escapeFn( buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.background.length>0? 'background: '+buttons.background+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -moz-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -o-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -ms-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" button svg, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button svg poly, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button svg rect, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button svg path, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover svg, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover svg poly, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover svg rect, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover svg path { ")
    ; __append(escapeFn( buttons.text_color.length>0? 'fill: '+buttons.text_color+';' : '' ))
    ; __append(" }")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}